import {
  Component,
  forwardRef,
  Input,
  OnChanges,
  SimpleChanges,
  Renderer2,
  ElementRef
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import {
  AgpFormUtil,
  CvaFormGroupComponent,
  ResetOptions
} from '@liberty-financial/agp-shared';
import { isNil } from 'lodash';

@Component({
  selector: 'spark-shared-percentage',
  templateUrl: './percentage.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SparkSharedPercentageComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SparkSharedPercentageComponent),
      multi: true
    }
  ]
})
export class SparkSharedPercentageComponent
  extends CvaFormGroupComponent<number | null>
  implements OnChanges
{
  @Input() label = '';
  @Input() isRequired = false;
  @Input() showHighlight = false;
  @Input() validations: {
    [index: string]: string;
  } = {};
  form = new FormControl<number | null>(null);
  formGroup = new FormGroup({
    percent: this.form
  });

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    super();
  }

  private get input(): HTMLInputElement | null {
    return this.elementRef.nativeElement.querySelector('input');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isRequired) {
      AgpFormUtil.Validators.updateRequiredIfNecessary(
        this.form,
        changes.isRequired.currentValue
      );
    }
  }

  protected reset(opts?: ResetOptions | undefined): void {
    this.form.reset(undefined, opts);
  }

  protected transformToModel = (value: number | null): number | null => {
    if (value === undefined || value === null) {
      return null;
    }

    return value / 100;
  };

  protected transformToForm = (value: number | null): number | null => {
    if (value === undefined || value === null) {
      return null;
    }
    return value * 100;
  };

  // write the value from the model to the view
  // note: otherwise reset does not clear view value
  writeValue(modelValue: number | null): void {
    const valueForInternalFormControl = this.transformToForm(modelValue);

    // solving the issue where the percentage value wasn't displaying correctly
    this.form.setValue(valueForInternalFormControl, { emitEvent: false });

    const displayValueForDom = isNil(valueForInternalFormControl)
      ? ''
      : String(valueForInternalFormControl);

    setTimeout(() => {
      const element = this.input;
      if (element) {
        this.renderer.setProperty(element, 'value', displayValueForDom);
      }
    }, 0);
  }
}
